/* Review mocks — fabricate one ReviewOut per product so the PDP renders. */

import { NETHRA_DATA } from "@/data/data";

const SAMPLES = [
  { rating: 5, title: "Reliable & fast",                body: "Order placed at 3:45 PM, dispatched same day. Batch traceability on every line item is a game changer for my GST filings.", author: { full_name: "Rajesh Pharmacy", role: "retailer" } },
  { rating: 5, title: "Cold chain handling is excellent", body: "Insulin pens arrived with a temperature log attached. Read-out was perfectly in range across two days of transit.", author: { full_name: "Dr. Kavita Menon", role: "clinician" } },
  { rating: 4, title: "Good margins, dependable",       body: "The retailer pricing tier is significantly better than my local distributor. Knocked off three tiers of trade margin on most lines.", author: { full_name: "Nikhil Chemist", role: "retailer" } },
  { rating: 5, title: "Single PO across categories",    body: "We consolidated 14 vendors down to nethrasap. Procurement saves about 9 hours a week.", author: { full_name: "Apollo Hospital", role: "clinician" } },
];

/** Build a seed list of reviews — 1 per featured product. */
export function seedReviews() {
  const out = [];
  let counter = 1;
  (NETHRA_DATA.products || []).forEach((p) => {
    if (!p.is_featured && !p.featured) return;
    const s = SAMPLES[counter % SAMPLES.length];
    out.push({
      id: `r-${counter}`,
      product_slug: p.slug,
      rating: s.rating,
      title: s.title,
      body: s.body,
      is_verified_purchase: true,
      created_at: new Date(Date.now() - counter * 86_400_000).toISOString(),
      updated_at: new Date(Date.now() - counter * 86_400_000).toISOString(),
      author: {
        id: `a-${counter}`,
        full_name: s.author.full_name,
        role: s.author.role,
      },
    });
    counter += 1;
  });
  return out;
}
